<template>
  <div class="detail-table">
      <div class="editWrapper">
            <div class="eTitle">{{title}}</div>
            <div class="orderNum">
              <div class="oTitle pTitle">题目序号: </div><div>{{index + 1}}</div>
            </div>
            <div class="subject">
              <p class="oTitle pTitle">题目内容: </p>
              <p>{{tableDetailData[index].subject}}</p>
            </div>
            <div class="options">
              <p class="pTitle">各个选项内容: </p>
              <div>
                <p>A. {{tableDetailData[index].soptionsArr[0]}}</p>
                <p>B. {{tableDetailData[index].soptionsArr[1]}}</p>
                <p>C. {{tableDetailData[index].soptionsArr[2]}}</p>
                <p>D. {{tableDetailData[index].soptionsArr[3]}}</p>
              </div>
            </div>
            <div class="rightResult">
              <p class="pTitle">正确的答案: {{tableDetailData[index].rightResult}}</p>
            </div>
            <div class="buttonWrapper">
              <div class="obuttonWrapper">
                <el-button type='primary' @click='no()'>关闭</el-button>
              </div>
            </div>
        </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'DetailTable',
  props: ['index'],
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      'tableDetailData': 'getAllTableInfo'
    }),
    title() {
      return '查看题目信息'
    }
  },
  methods: {
    no() {
      this.$emit('cancleD', false);
    }
  },
  mounted() {
    // console.log('000000', this.tableDetailData)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/mixin.scss';

.detail-table {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 999;
  .editWrapper {
    position: absolute;
    top: 40px;
    width: 50%;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    border-radius: 5px;
    background: white;
    padding: 8px 5px;
    line-height: 1.5;
    word-wrap: break-word;
    word-break: normal;
    text-align: justify;
    .pTitle {
      padding-bottom: 6px;
    }
    .eTitle {
      text-align: center;
      font-weight: bold;
    }
    .buttonWrapper {
      .obuttonWrapper {
        text-align: right;
        .el-button--primary {
          background-color: #003c8d;
          border-color: #003c8d;
        }
      }
    }
    .subject {
      .subjectWrapper {
          padding: 5px 15px;
          border-radius: 4px;
          border: 1px solid #DCDFE6;
      }
    }
    .options {
      margin-top: 10px;
    }
    .rightResult {
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DetailTable.vue